import {Card, FormControl, openDialog} from 'platform/components';

import {UseFormReturn, useWatch} from 'react-hook-form';

import {isNotNil} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import {TemplateContextEnum} from '@dms/api/core';
import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

import {FormValues} from '../types/FormValues';
import {SmsMessagePreview} from './SmsMessagePreview';
import {TemplateBodyField} from './TemplateBodyField';

interface SmsChannelControlProps {
  control: FormControl<FormValues>;
  formApi: UseFormReturn<FormValues>;
  context: TemplateContextEnum | Nullish;
}

export function SmsChannelControl(props: SmsChannelControlProps) {
  const isBodyError = isNotNil(props.formApi.formState.errors.smsContextTemplateBody);

  const [isSmsEnabled, isAutomatizationEnabled, smsContextTemplateBody] = useWatch({
    control: props.control,
    name: ['smsEnabled', 'enabled', 'smsContextTemplateBody'],
  });

  const handlePreview = () => {
    if (!props.context) {
      return;
    }

    const smsBody = props.formApi.getValues('smsContextTemplateBody') || '';
    openDialog(<SmsMessagePreview body={smsBody} context={props.context} />, {});
  };

  return (
    <Card
      isExpandable
      isClosedByDefault
      variant="inlineWhite"
      colorStripe={isBodyError ? 'red' : undefined}
      title={i18n.t('general.labels.sms')}
      actions={[
        {
          type: 'button',
          variant: 'link',
          title: i18n.t('general.labels.smsPreview'),
          size: 'small',
          leftIcon: 'view',
          onClick: handlePreview,
          isDisabled: isNilOrEmpty(smsContextTemplateBody) || !props.context,
        },
      ]}
      control={{
        type: 'checkbox',
        value: isSmsEnabled,
        isDisabled: !isAutomatizationEnabled,
        onChange: (value) => {
          props.formApi.setValue('smsEnabled', value);

          if (!value) {
            props.formApi.clearErrors('smsContextTemplateBody');
          }
        },
      }}
    >
      <TemplateBodyField
        control={props.control}
        name="smsContextTemplateBody"
        context={props.context}
        label={i18n.t('general.labels.message')}
        isDisabled={!isSmsEnabled || !isAutomatizationEnabled}
        minHeight={25}
      />
    </Card>
  );
}
